module.exports = __webpack_public_path__ + "img/link.cce490a4.png";